<template>
  <div class="offers-column offers-column_positions d-contents">
    <div class="offers-table-cell offers-table-cell_sticky offers-table-cell_navigation">
      <Button size="small" type="func" left-icon="chevron-left" @click="handleScroll(false)">{{
        $t('Scroll left')
      }}</Button>
      <Button size="small" type="func" right-icon="chevron-right" @click="handleScroll">{{
        $t('Scroll right')
      }}</Button>
    </div>
    <div class="offers-table-cell offers-table-cell_sticky" :style="{ 'grid-row': '2 / 3' }">
      {{ $t('Details') }}
    </div>
    <router-link
      v-for="(value, idx) in tenderOffers.lists"
      :key="value.id"
      class="offers-table-cell offers-table-cell_sticky link offers-table-cell_list-name"
      :to="{ name: 'tender-list', params: { tenderListId: value.id } }"
      :style="{ 'grid-row': `${idx + 3} / ${idx + 4}` }"
    >
      <span class="text-tertiary">{{ idx + 1 }}</span>
      <span class="text-primary truncate">{{ value.title }}</span>
    </router-link>
    <div
      class="offers-table-cell offers-table-cell_sticky"
      :style="{ 'grid-row': `${listsCount + 4} / ${listsCount + 5}` }"
    >
      {{ $t('Taxes') }} & {{ $t('Parameters') }}
    </div>
    <div
      class="offers-table-cell offers-table-cell_sticky"
      :style="{ 'grid-row': `${listsCount + 5} / ${listsCount + 6}` }"
    >
      {{ $t('Files') }}
    </div>
  </div>
</template>

<script>
  import Button from '@/components/ui-v2/Button';

  export default {
    name: 'TenderOffersLegend',
    components: {
      Button,
    },
    props: {
      tenderOffers: {
        type: Object,
        required: true,
      },
      isIncomingTendersTable: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      listsCount() {
        return this.tenderOffers?.lists?.length || 0;
      },
    },
    methods: {
      handleScroll(right = true) {
        let scrollBar = document.querySelector('#tender-summary-content');
        scrollBar.scrollLeft = right ? scrollBar.scrollLeft + 180 : scrollBar.scrollLeft - 180;
      },
    },
  };
</script>
